/**
 * @global
 * @namespace
 */
class PromoteComment
{
	/** @type {PopupHelper} */
	_popupHelper = null;

	constructor()
	{
		let thisObj = this;
		this._popupHelper = new PopupHelper("#promote-comment-popup", {
			popupOKCallback: thisObj._submitRequest.bind(thisObj),
			resetFieldsCallback: thisObj._resetFields.bind(thisObj),
		});
	}

	open(endpoint, commentText, commentsContainersSelector, thisCommentId)
	{
		this._popupHelper.open(endpoint, commentText, commentsContainersSelector, thisCommentId);
	}

	_resetFields(endpoint, commentText, commentsContainersSelector, thisCommentId)
	{
		$(`${this._popupHelper.containerSelector} .comment-content`).text(commentText);
		$(`${this._popupHelper.containerSelector} .comment-container`).remove();

		const $template = $(`${this._popupHelper.containerSelector} .comment-template`);
		const $templateParent = $template.parent();
		const $comments = $(commentsContainersSelector);
		const $emptyCommentsMessage = $(`${this._popupHelper.containerSelector} .no-other-comments-message`);
		let commentsCopied = 0;

		$comments.each(function (index, element)
		{
			const commentId = $(element).data("id");
			if (thisCommentId == commentId)
				return;
			const $newElement = $template.clone(false, false);
			const $label = $newElement.children("label");
			const $input = $newElement.children("input");
			const id = `comment-${commentId}`;

			$input
				.attr("name", "select-comment")
				.attr("id", id)
				.val(commentId);
			$label
				.attr("for", id)
				.attr("id", `label-${id}`)
				.text($(element).text().replace("\n", "<br/>"));

			$newElement
				.removeClass("comment-template")
				.addClass("comment-container")
				.show()
				.appendTo($templateParent);
			commentsCopied++;
		});

		if (commentsCopied == 0) {
			$emptyCommentsMessage.show();
		} else {
			$emptyCommentsMessage.hide();
		}
	}

	_submitRequest(endpoint, commentText)
	{
		const $checkedComments = $(`${this._popupHelper.containerSelector} input:checked[name="select-comment"]`);

		const popupHelper = this._popupHelper;
		const data = {
			ideaName: $(`${this._popupHelper.containerSelector} input[name="idea-name"]`).val(),
			otherCommentIds: JSON.stringify($checkedComments
				.map(function (index, checkbox)
				{
					return checkbox.value
				})
				.toArray())
		};
		
		popupHelper.showLoading();

		dataAction.callClientPostEndpoint(
			endpoint,
			data,
			function (response)
			{
				popupHelper.close();
				window.location.href = response;
			},
			popupHelper.defaultResponseErrorHandler.bind(popupHelper),
			popupHelper.hideLoading.bind(popupHelper)
		);
	}
}